import { Component } from '@angular/core';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html'
})
export class DatePickerComponent {
  title = 'datepicker';
}



// WEBPACK FOOTER //
// ./src/app/shared/date-picker/datepicker.component.ts